module.exports = __webpack_public_path__ + "static/img/logoJY.2aa4bfe8.jpg";